// extracted by mini-css-extract-plugin
export default {"container":"GenericScreen_container__zzorr","page":"GenericScreen_page__x2r4y"};